document.addEventListener('DOMContentLoaded', function() {
  // Function to handle filters
  function setupFilters() {
    // Find all facet disclosure elements
    const facetDisclosures = document.querySelectorAll('.facets__disclosure');
    
    // Process each disclosure
    facetDisclosures.forEach(function(disclosure) {
      const summary = disclosure.querySelector('.facets__summary');
      const display = disclosure.querySelector('.facets__display');
      
      if (!summary || !display) return;
      
      // Replace the default behavior
      summary._clickHandler = summary._clickHandler || summary.onclick;
      summary.onclick = function(e) {
        // Allow the default toggle behavior
      };
      
      // Prevent clicks in the display from closing
      display.addEventListener('click', function(e) {
        e.stopPropagation();
      }, true);
      
      // Prevent input interactions from closing
      const inputs = display.querySelectorAll('input, select, button, a, label');
      inputs.forEach(function(input) {
        input.addEventListener('mousedown', function(e) {
          e.stopPropagation();
        }, true);
        
        input.addEventListener('click', function(e) {
          e.stopPropagation();
          e.preventDefault(); // Prevent the default action
          
          // Instead, handle the action manually
          if (e.currentTarget.tagName === 'INPUT' && e.currentTarget.type === 'checkbox') {
            e.currentTarget.checked = !e.currentTarget.checked;
          }
          
          if (e.currentTarget.tagName === 'LABEL' && e.currentTarget.querySelector('input')) {
            const checkbox = e.currentTarget.querySelector('input');
            checkbox.checked = !checkbox.checked;
          }
        }, true);
      });
      
      // Stop the built-in document click handler
      document.addEventListener('click', function(e) {
        if (display.contains(e.target)) {
          e.stopPropagation();
        }
      }, true);
    });
  }
  
  // Initial setup
  setupFilters();
  
  // Monitor for DOM changes that might add new filters
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        setupFilters();
      }
    });
  });
  
  // Start observing the body
  observer.observe(document.body, { childList: true, subtree: true });
});